!function() {
  "use strict";
  customElements.get("product-form") || customElements.define("product-form", class extends HTMLElement {
    constructor() {
      super();
    }
    initStickyElement() {
      const t = this.querySelector("[data-sticky]") || this.form?.hasAttribute("id") && document.querySelector(`[data-sticky="${this.form?.getAttribute("id")}"]`);
      t ? (this.sticky = t, this.setupStickyBehavior()) : new MutationObserver(((t, e) => {
        for (const a of t) if ("childList" === a.type) {
          const t = Array.from(a.addedNodes).find((t => 1 === t.nodeType && t.matches(`[data-sticky="${this.form?.getAttribute("id")}"]`)));
          if (t) return this.sticky = t, this.setupStickyBehavior(), this.form?.getAttribute("id") && t.querySelectorAll(`[form="${this.form.getAttribute("id")}"]`).forEach((t => t.addEventListener("change", this.onChange.bind(this)))), 
          void e.disconnect();
        }
      })).observe(document.body, {
        childList: !0,
        subtree: !0
      });
    }
    getParent() {
      return this.closest("[data-product]") || this.closest(".shopify-section");
    }
    getTarget(t = !1) {
      const e = t?.target?.getAttribute("form") || this.form?.getAttribute("id");
      return e ? [ document, `[form="${e}"]` ] : [ this, "" ];
    }
    buttons() {
      const [t, e] = this.getTarget();
      return t.querySelectorAll(`${e}[type="submit"]`);
    }
    onChange(t) {
      this.updateOptions(t), this.updateMasterId(t), this.updatePrice(), this.updateInventory(), 
      this.updateURL(), this.updateVariantImages(), this.currentVariant ? this.currentVariant.available ? this.updateButton("available") : this.updateButton("soldOut") : this.updateButton("unavailable"), 
      this.dispatchEvent(new CustomEvent("variant:change", {
        bubbles: !0,
        detail: {
          variant: this.currentVariant
        }
      }));
      const e = t.target.closest("[data-select-modal-wrapper]")?.querySelector("[data-select-modal-trigger]");
      e && (e.checked = !1);
    }
    updateOptions(t) {
      const [e, a] = this.getTarget(t);
      e.querySelectorAll(`${a}[data-option-title="${t.target.name}"]`).forEach((e => e.textContent = t.target.value)), 
      e.querySelectorAll(`${a}[name="${t.target.name}"]`).forEach((e => {
        "SELECT" === e.tagName ? e.value = t.target.value : e.checked = e.value == t.target.value;
      }));
      const i = Array.from(this.querySelectorAll('input[name^="option"], select[name^="option"]')), r = [ ...new Set(i.map((t => t.name))) ].sort(((t, e) => parseInt(t.replace("option", "")) - parseInt(e.replace("option", ""))));
      this.options = r.map((t => {
        const e = this.querySelector(`select[name="${t}"], input[name="${t}"]:checked`);
        return e ? e.value : null;
      })), "true" === this.dataset.updateAvailability && this.updateAvailability(t);
    }
    updateAvailability(t) {
      this.options && this.querySelectorAll('input[name^="option"], select[name^="option"]').forEach((t => {
        const e = t.name, a = t.value, i = parseInt(e.replace("option", "")) - 1, r = [ ...this.options ];
        r[i] = a;
        const n = this.getVariantData().some((t => !!t.available && !t.options.map(((t, e) => {
          const a = r[e];
          return null == a || a.toString().trim() == t.toString().trim();
        })).includes(!1))), s = t.closest("label");
        s && s.querySelectorAll("[data-oos-indicator]").forEach((t => {
          n ? t.classList.add("hidden") : t.classList.remove("hidden");
        })), n ? (t.removeAttribute("aria-out-of-stock"), t.disabled = !1, s && (s.removeAttribute("data-out-of-stock"), 
        s.setAttribute("data-close", ""), s.removeAttribute("for"), s.removeAttribute("data-event"), 
        s.removeAttribute("data-click-action"), s.removeAttribute("data-product-name"), 
        s.removeAttribute("aria-label"), s.removeAttribute("data-value"))) : (t.setAttribute("aria-out-of-stock", "true"), 
        t.disabled = !0, s && (s.setAttribute("data-out-of-stock", "true"), s.removeAttribute("data-close"), 
        s.setAttribute("for", `StockModal-${this.dataset.productId}`), s.setAttribute("data-event", "notify_me_open"), 
        s.setAttribute("data-click-action", "open"), s.setAttribute("data-product-name", this.dataset.productTitle), 
        s.setAttribute("aria-label", this.dataset.oosAriaLabel), s.setAttribute("data-value", a)));
      }));
    }
    updateMasterId(t) {
      if (1 === this.getVariantData().length ? this.currentVariant = this.getVariantData()[0] : this.currentVariant = this.getVariantData().find((t => !t.options.map(((t, e) => this.options[e] === t)).includes(!1))), 
      this.querySelector('[name="id"]').value = this.currentVariant ? this.currentVariant.id : "", 
      this.currentVariant?.title) {
        const [e, a] = this.getTarget(t);
        e.querySelectorAll(`${a}[data-variant-title]`).forEach((t => t.dataset.variantTitle = this.currentVariant.title));
      }
    }
    updateInventory() {
      const t = this.querySelector("[data-inventory]");
      t && (this.lowInventory && this.currentVariant && this.currentVariant.inventory_quantity > 0 && this.currentVariant.inventory_quantity <= this.lowInventory && "shopify" == this.currentVariant.inventory_management && "deny" == this.currentVariant.inventory_policy ? t.innerText = window.strings.inventory.low.replace("{{ count }}", this.currentVariant.inventory_quantity) : t.innerText = "");
    }
    updatePrice() {
      var t = this.getProductData().price, e = this.getProductData().compare_at_price;
      this.currentVariant && (t = this.currentVariant.price, e = this.currentVariant.compare_at_price), 
      this.getParent().querySelectorAll("[data-price]").forEach((e => e.innerHTML = Shopify.formatMoney(t, Shopify.money_format))), 
      e > t ? this.getParent().querySelectorAll("[data-compare-at-price]").forEach((t => t.innerHTML = Shopify.formatMoney(e, Shopify.money_format))) : this.getParent().querySelectorAll("[data-compare-at-price]").forEach((t => t.textContent = ""));
    }
    updateVariantImages() {
      if (!this.currentVariant) return;
      const t = this.getParent().querySelectorAll("[data-variants]");
      if (0 === t.length) return;
      let e = 0;
      t.forEach((t => {
        t.dataset.variants?.split(",").includes(this.currentVariant?.id.toString()) ? (t.classList.remove("hidden"), 
        0 == e ? t.classList.add("col-span-2") : t.classList.remove("col-span-2")) : (t.classList.add("hidden"), 
        t.classList.remove("col-span-2")), e++;
      })), this.getParent().querySelectorAll("[data-product-image]:not([data-variants])").forEach((t => {
        this.currentVariant.image ? t.classList.add("hidden") : t.classList.remove("hidden");
      })), this.getParent().querySelectorAll('[name="properties[_image]"]').forEach((t => t.value = this.currentVariant.image));
    }
    updateButton(t) {
      var e = this.dataset.selectText || window.strings.selectOptions, a = !0;
      switch (t) {
       case "available":
        e = window.strings.addToCart, a = !1;
        break;

       case "soldOut":
        e = window.strings.soldOut;
      }
      this.buttons().forEach((t => {
        t.disabled = a, t.textContent = e, a ? (t.classList.add("button-outline"), t.classList.remove("button-primary")) : (t.classList.add("button-primary"), 
        t.classList.remove("button-outline"));
      }));
    }
    updateURL() {
      if (this.getVariantData().length <= 1 || !this.currentVariant || this.hasAttribute("data-modal") || !this.querySelector('[type="submit"]')) return;
      const t = new URLSearchParams(location.search);
      t.set("variant", this.currentVariant.id), window.history.replaceState({}, "", `${this.dataset.url}?${t.toString()}`);
    }
    getProductData() {
      return this.querySelector('[type="application/json"][data-product-json]') ? this.productData = this.productData || JSON.parse(this.querySelector('[type="application/json"][data-product-json]').textContent) : this.productData = this.productData || JSON.parse(this.querySelector('[type="application/json"]').textContent), 
      this.productData;
    }
    getVariantData() {
      return this.querySelector('[type="application/json"][data-variant-json]') ? this.variantData = this.variantData && this.variantData[0].inventory_policy ? this.variantData : JSON.parse(this.querySelector('[type="application/json"][data-variant-json]').textContent) : this.variantData = this.variantData || this.getProductData().variants, 
      this.variantData;
    }
    onSubmitHandler(t) {
      t.stopPropagation(), t.stopImmediatePropagation(), t.preventDefault(), Shopify.addToCart(this.form);
    }
    setupFirstInputElement() {
      const t = this.querySelector('select[name^="option"],input[type="radio"]');
      if (t) if ("SELECT" === t.tagName) {
        const e = Array.from(t.options).find((t => !t.disabled))?.value;
        if (e) {
          t.value = e;
          const a = new Event("input", {
            bubbles: !0,
            cancelable: !0,
            composed: !0
          }), i = new Event("change", {
            bubbles: !0,
            cancelable: !0
          });
          t.dispatchEvent(a), t.dispatchEvent(i);
        }
      } else 1 === this.getVariantData().length && t.click();
    }
    setupOutofStockLabelClick() {
      this.querySelectorAll("label[data-out-of-stock]").forEach((t => {
        t.addEventListener("click", (t => {
          const e = t.target.closest("label");
          if (!e) return;
          const a = e.getAttribute("for");
          if (!a) return;
          const i = document.getElementById(a);
          if (!i) return;
          const r = i.nextElementSibling;
          if (!r) return;
          const n = r.querySelector('select[name^="option"]');
          if (!n) return;
          const s = e.getAttribute("data-value");
          if (!s) return;
          n.value = s;
          const o = new Event("input", {
            bubbles: !0,
            cancelable: !0,
            composed: !0
          }), c = new Event("change", {
            bubbles: !0,
            cancelable: !0
          });
          n.dispatchEvent(o), n.dispatchEvent(c);
        }));
      }));
    }
    connectedCallback() {
      this.form = this.querySelector("form"), this.form ? this.init() : new MutationObserver(((t, e) => {
        this.form = this.querySelector("form"), this.form && (this.init(), e.disconnect());
      })).observe(this, {
        childList: !0,
        subtree: !0
      });
    }
    init() {
      this.form = this.form || this.querySelector("form"), this.sticky = null, this.lowInventory = parseInt(this.dataset.lowInventory), 
      this.currentVariant = !1, this.form?.hasAttribute("id") && this.form?.getAttribute("id") ? document.querySelectorAll(`[form="${this.form?.getAttribute("id")}"]`).forEach((t => t.addEventListener("change", this.onChange.bind(this)))) : this.addEventListener("change", this.onChange.bind(this)), 
      this.initStickyElement(), this.setupFirstInputElement(), this.setupOutofStockLabelClick(), 
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      let t = this.querySelectorAll("[data-quantity]");
      this.sticky && (t = [ ...t, ...this.sticky.querySelectorAll("[data-quantity]") ]), 
      t.forEach((t => {
        t.addEventListener("click", (e => {
          e.preventDefault(), e.stopPropagation();
          let a = parseInt(t.parentNode.querySelector('[name="quantity"]').value);
          a = t.hasAttribute("data-minus") ? Math.max(1, a - 1) : a += 1, this.getParent().querySelectorAll('[name="quantity"]').forEach((t => t.value = a));
        })), t.classList.remove("hidden");
      })), this.classList.remove("opacity-50", "cursor-not-allowed");
    }
    setupStickyBehavior() {
      if (!this.sticky) return;
      const t = this.querySelector("[data-atc]"), e = document.getElementById("HelpButtonBubble");
      t && new IntersectionObserver((t => {
        const a = t[0];
        if (!a.isIntersecting && a.target.getBoundingClientRect().y < window.innerHeight) {
          if (this.sticky.classList.remove("translate-y-full", "opacity-0", "pointer-events-none"), 
          e) {
            const t = this.sticky.offsetHeight;
            e.style.transform = `translateY(-${t}px)`;
          }
        } else this.sticky.classList.add("translate-y-full", "opacity-0", "pointer-events-none"), 
        e && (e.style.transform = "");
      }), {
        rootMargin: "-100px 0px 0px 0px"
      }).observe(t), this.sticky.querySelectorAll("[data-scrollbar]").forEach((t => {
        t.parentNode.addEventListener("scroll", (() => {
          let e = Math.min(Math.max(0, t.parentNode.scrollTop / (t.parentNode.scrollHeight - t.parentNode.offsetHeight) * 100), 100);
          e *= (t.parentNode.children.length - 6) / (t.parentNode.children.length - 5), t.style.setProperty("--top", `${e}%`);
        }), {
          passive: !0
        });
      }));
    }
  });
}();